import { render, staticRenderFns } from "./detail.vue?vue&type=template&id=e957d470&scoped=true&"
import script from "./detail.vue?vue&type=script&lang=js&"
export * from "./detail.vue?vue&type=script&lang=js&"
import style0 from "./detail.vue?vue&type=style&index=0&id=e957d470&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e957d470",
  null
  
)

/* custom blocks */
import block0 from "./locales.json?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fhome%2Fgitlab-runner%2Fbuilds%2F7624f89f%2F0%2Ftokyo-auction%2Ftokyo-auction-frontend%2Fsrc%2Fviews%2Fguide%2Fdetail.vue"
if (typeof block0 === 'function') block0(component)

export default component.exports